import { render, staticRenderFns } from "./PaxInfoCAA.vue?vue&type=template&id=681035b6&"
import script from "./PaxInfoCAA.vue?vue&type=script&lang=ts&"
export * from "./PaxInfoCAA.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports